export default "__VITE_ASSET__CE_Tf90K__"